export const MediaResourcesDA = {
  title: "Medier",
  intro: "Se Aida i forskellige medier og interviews",
  podcastsTitle: "Podcasts",
  podcastsIntro: "Lyt til Aida i podcasts om børn, teknologi og læring",
  documentariesTitle: "Dokumentarer",
  mediaLogosTitle: "Mediepartnere",
  mediaLogosIntro: "Aida samarbejder med følgende medier",

  // Video links
  video21Title: "Hvad gør doomscrolling EGENTLIG ved hjernen?",
  video21Description:
    "Kan TikTok og doomscrolling faktisk give dig ADHD-lignende symptomer? Og kan man måle “brainrot” i hjernen?",
  video21Url: "https://www.youtube.com/watch?v=DTtk7ztPlV8&t=374s",

  video22Title: "ØDELÆGGER FOR MEGET SKÆRMTID DIT FOKUS? FT. Aida Bikic",
  video22Description:
    "Hvorfor kan man se TikTok i 3 timer, men ikke en film i 10 minutter uden at tjekke telefonen?",
  video22Url: "https://youtu.be/Y0X2QlhdgbU?si=Agy_iMNnwj5I7oRG",

  video1Title: "NDR Panorama 3",
  video1Description: "Interview om skærmbrug og børn",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Helfen Jugendlichen nur noch Verbote?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digital sundhed og børn",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Skærmtid røver børn for deres kreativitet",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digitale forældrestrategier",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Skærmtidsretningslinjer for familier",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digital afrusning",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Koncentration i den digitale tidsalder",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Forældreskab i den digitale verden",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Børns mentale sundhed og skærme",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zonen (7 dage uden sociale medier ændrede mit liv)",
  video15Description: "Digital læsning for familier",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Børn og deres digitale verden",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Skærmtidsforskningsresultater",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Teknologi og børns udvikling",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Mobilfri når skærmen går i sort",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Fake eller fakta - kaniner hopper på trampolin",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Ser du for meget skærm?",
  podcast1Description: "Kraniebrud podcast om skærmbrug",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic på CyberSundhed podcast",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "CyberSundhed - Boundaries give children security",
  podcast4Description: "Digital sundhed og børn",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Interview med Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Hvorfor har jeg så svært ved at lægge min mobil væk?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  podcast7Title: "WDR Studio Interview",
  podcast7Description:
    "Dr. Morsi Abdallah - Facharzt für Kinder- und Jugendpsychiatrie",
  podcast7Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/studiogespraech-dr-morsi-abdallah-facharzt-fuer-kinder-und-jugendpsychiatrie-und-psychotherapie-100.html",

  podcast8Title: "Psychologos Podcast",
  podcast8Description: "Social Media Teil II - Asocial Media mit Aida Bikic",
  podcast8Url:
    "https://www.podcast.de/episode/672508393/social-media-teil-ii-asocial-media-mit-aida-bikic",

  podcast9Title: "WDR Cosmo",
  podcast9Description: "Počinje digitalna detoksikacija školstva",
  podcast9Url:
    "https://www1.wdr.de/mediathek/audio/cosmo/bosnisch-kroatisch-serbisch/audio-pocinje-digitalna-detoksikacija-skolstva-102.html",

  podcast10Title: "YouTube Interview BIH",
  podcast10Description: "Digitalna detoksikacija",
  podcast10Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  podcast11Title: "Avaz Interview",
  podcast11Description: "Skærmbrug og børn",
  podcast11Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY&t=190s",

  watchButton: "Se video",
  learnMoreButton: "Læs mere",
};

export const MediaResourcesEN = {
  title: "Media",
  intro: "Watch Aida in various media and interviews",
  podcastsTitle: "Podcasts",
  podcastsIntro:
    "Listen to Aida in podcasts about children, technology and learning",
  documentariesTitle: "Documentaries",
  mediaLogosTitle: "Media Partners",
  mediaLogosIntro: "Aida collaborates with the following media outlets",

  // Video links
  video21Title: "Hvad gør doomscrolling EGENTLIG ved hjernen?",
  video21Description:
    "Can TikTok and doomscrolling actually give you ADHD-like symptoms? And can “brain rot” be measured in the brain?",
  video21Url: "https://www.youtube.com/watch?v=DTtk7ztPlV8&t=374s",

  video22Title: "ØDELÆGGER FOR MEGET SKÆRMTID DIT FOKUS? FT. Aida Bikic",
  video22Description:
    "Why can you watch TikTok for 3 hours, but not a film for 10 minutes without checking your phone?",
  video22Url: "https://youtu.be/Y0X2QlhdgbU?si=Agy_iMNnwj5I7oRG",

  video1Title: "NDR Panorama 3",
  video1Description: "Interview about screen use and children",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Do young people only need prohibitions?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digital health and children",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Screen time robs children of their creativity",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digital parenting strategies",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Screen time guidelines for families",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digital detoxification",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Concentration in digital age",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Parenting in digital world",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Children's mental health and screens",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zonen (7 days without social media changed my life)",
  video15Description: "Digital literacy for families",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Children and their digital world",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Screen time research findings",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Technology and child development",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Mobile-free when the screen goes black",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Fake or fact - rabbits jumping on trampoline",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Do you watch too much screen?",
  podcast1Description: "Kraniebrud podcast about screen use",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic on CyberSundhed podcast",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "CyberSundhed - Boundaries givee children security",
  podcast4Description: "Digital health and children",
  // Keep URL, just title/desc updated above in DA block as needed
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Interview with Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Why do I have such a hard time putting my phone away?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  podcast7Title: "WDR Studio Interview",
  podcast7Description:
    "Dr. Morsi Abdallah - Specialist for Child and Adolescent Psychiatry",
  podcast7Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/studiogespraech-dr-morsi-abdallah-facharzt-fuer-kinder-und-jugendpsychiatrie-und-psychotherapie-100.html",

  podcast8Title: "Psychologos Podcast",
  podcast8Description: "Social Media Part II - Asocial Media with Aida Bikic",
  podcast8Url:
    "https://www.podcast.de/episode/672508393/social-media-teil-ii-asocial-media-mit-aida-bikic",

  podcast9Title: "WDR Cosmo",
  podcast9Description: "Digital detoxification of schools begins",
  podcast9Url:
    "https://www1.wdr.de/mediathek/audio/cosmo/bosnisch-kroatisch-serbisch/audio-pocinje-digitalna-detoksikacija-skolstva-102.html",

  podcast10Title: "YouTube Interview BIH",
  podcast10Description: "Digital detoxification",
  podcast10Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  podcast11Title: "Avaz Interview",
  podcast11Description: "Screen use and children",
  podcast11Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY&t=190s",

  watchButton: "Watch video",
  learnMoreButton: "Learn more",
};

export const MediaResourcesDE = {
  title: "Medien",
  intro: "Sehen Sie Aida in verschiedenen Medien und Interviews",
  podcastsTitle: "Podcasts",
  podcastsIntro:
    "Hören Sie Aida in Podcasts über Kinder, Technologie und Lernen",
  documentariesTitle: "Dokumentationen",
  mediaLogosTitle: "Medienpartner",
  mediaLogosIntro: "Aida arbeitet mit folgenden Medien zusammen",

  // Video links
  video21Title: "Hvad gør doomscrolling EGENTLIG ved hjernen?",
  video21Description:
    "Können TikTok und Doomscrolling tatsächlich ADHS-ähnliche Symptome verursachen? Und lässt sich „Brainrot“ im Gehirn messen?",
  video21Url: "https://www.youtube.com/watch?v=DTtk7ztPlV8&t=374s",

  video22Title: "ØDELÆGGER FOR MEGET SKÆRMTID DIT FOKUS? FT. Aida Bikic",
  video22Description:
    "Warum kann man TikTok 3 Stunden lang schauen, aber keinen Film 10 Minuten lang, ohne aufs Handy zu sehen?",
  video22Url: "https://youtu.be/Y0X2QlhdgbU?si=Agy_iMNnwj5I7oRG",

  video1Title: "NDR Panorama 3",
  video1Description: "Interview über Bildschirmnutzung und Kinder",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Brauchen Jugendliche nur noch Verbote?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digitale Gesundheit und Kinder",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Bildschirmzeit raubt Kindern ihre Kreativität",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digitale Erziehungsstrategien",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Bildschirmzeit-Richtlinien für Familien",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digitale Entgiftung",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Konzentration im digitalen Zeitalter",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Erziehung in der digitalen Welt",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Kinderpsychische Gesundheit und Bildschirme",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zonen (7 Tage ohne soziale Medien veränderten mein Leben)",
  video15Description: "Digitale Kompetenz für Familien",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Kinder und ihre digitale Welt",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Bildschirmzeit-Forschungsergebnisse",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Technologie und kindliche Entwicklung",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Mobilfrei wenn der Bildschirm schwarz wird",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Fake oder Fakt - Kaninchen springen auf Trampolin",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Siehst du zu viel Bildschirm?",
  podcast1Description: "Kraniebrud Podcast über Bildschirmnutzung",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic im CyberSundhed Podcast",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "YouTube Interview",
  podcast4Description: "Digitale Gesundheit und Kinder",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Interview mit Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Warum fällt es mir so schwer, mein Handy wegzulegen?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  podcast7Title: "WDR Studio Interview",
  podcast7Description:
    "Dr. Morsi Abdallah - Facharzt für Kinder- und Jugendpsychiatrie",
  podcast7Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/studiogespraech-dr-morsi-abdallah-facharzt-fuer-kinder-und-jugendpsychiatrie-und-psychotherapie-100.html",

  podcast8Title: "Psychologos Podcast",
  podcast8Description: "Social Media Teil II - Asocial Media mit Aida Bikic",
  podcast8Url:
    "https://www.podcast.de/episode/672508393/social-media-teil-ii-asocial-media-mit-aida-bikic",

  podcast9Title: "WDR Cosmo",
  podcast9Description: "Počinje digitalna detoksikacija školstva",
  podcast9Url:
    "https://www1.wdr.de/mediathek/audio/cosmo/bosnisch-kroatisch-serbisch/audio-pocinje-digitalna-detoksikacija-skolstva-102.html",

  podcast10Title: "YouTube Interview BIH",
  podcast10Description: "Digitalna detoksikacija",
  podcast10Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  podcast11Title: "Avaz Interview",
  podcast11Description: "Bildschirmnutzung und Kinder",
  podcast11Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY&t=190s",

  watchButton: "Video ansehen",
  learnMoreButton: "Mehr erfahren",
};

export const MediaResourcesBS = {
  title: "Mediji",
  intro: "Pogledajte Aidu u različitim medijima i intervjuima",
  podcastsTitle: "Podcast",
  podcastsIntro: "Slušajte Aidu u podcastovima o djeci, tehnologiji i učenju",
  documentariesTitle: "Dokumentarci",
  mediaLogosTitle: "Medijski partneri",
  mediaLogosIntro: "Aida sarađuje sa sljedećim medijima",

  // Video links
  video21Title: "Hvad gør doomscrolling EGENTLIG ved hjernen?",
  video21Description:
    "Mogu li TikTok i doomscrolling zaista izazvati simptome slične ADHD-u? I može li se “brainrot” izmjeriti u mozgu?",
  video21Url: "https://www.youtube.com/watch?v=DTtk7ztPlV8&t=374s",

  video22Title: "ØDELÆGGER FOR MEGET SKÆRMTID DIT FOKUS? FT. Aida Bikic",
  video22Description:
    "Zašto možete gledati TikTok 3 sata, a film ne možete 10 minuta bez provjere telefona?",
  video22Url: "https://youtu.be/Y0X2QlhdgbU?si=Agy_iMNnwj5I7oRG",

  video1Title: "NDR Panorama 3",
  video1Description: "Intervju o korištenju ekrana i djeci",
  video1Url:
    "https://www.ndr.de/fernsehen/sendungen/panorama3/Panorama-3,sendung1549306.html",

  video2Title: "SRF Puls",
  video2Description:
    "Glücksfresser Smartphone - Da li mladima trebaju samo zabrane?",
  video2Url:
    "https://www.srf.ch/play/tv/puls/video/gluecksfresser-smartphone---helfen-jugendlichen-nur-noch-verbote?urn=urn:srf:video:718034d7-11d4-4736-abad-358e32ee2328",

  video5Title: "CyberSundhed - Boundaries give children security",
  video5Description: "Digitalno zdravlje i djeca",
  video5Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  video8Title: "Go' morgen Danmark & Go' aften Live",
  video8Description: "Vrijeme pred ekranom krade djeci njihovu kreativnost",
  video8Url: "https://www.facebook.com/watch/?v=1159225205443624",

  video9Title: "Headspace",
  video9Description: "Digitalne strategije roditeljstva",
  video9Url: "https://www.facebook.com/watch/?v=1064828598575157",

  video10Title: "Headspace",
  video10Description: "Smjernice za vrijeme pred ekranom za obitelji",
  video10Url: "https://www.facebook.com/watch/?v=1092654535612773",

  video11Title: "BHRT Radiotelevizija Bosne I Hercegovine",
  video11Description: "Digitalna detoksikacija",
  video11Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  video12Title: "FACE HD TV",
  video12Description: "Koncentracija u digitalnom dobu",
  video12Url: "https://www.youtube.com/watch?v=52YMLkfUQvQ",

  video13Title: "ALFA TV HD",
  video13Description: "Roditeljstvo u digitalnom svijetu",
  video13Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY",

  video14Title: "PSYCHOLOGOS Podcast",
  video14Description: "Mentalno zdravlje djece i ekrani",
  video14Url: "https://www.youtube.com/watch?v=OZd7SrqAwhY",

  video15Title: "Zona (7 dana bez društvenih mreža promijenilo je moj život)",
  video15Description: "Digitalna pismenost za obitelji",
  video15Url: "https://www.youtube.com/watch?v=tXfJsYRKeR4",

  video16Title: "WDR Local Time",
  video16Description: "Djeca i njihov digitalni svijet",
  video16Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/kinder-und-ihre-digitale-welt-100.html",

  video17Title: "TV2 News",
  video17Description: "Rezultati istraživanja vremena pred ekranom",
  video17Url: "https://www.youtube.com/watch?v=9Bm7BjFYL4Q",

  video18Title: "DR Ultra",
  video18Description: "Tehnologija i razvoj djece",
  video18Url: "https://www.youtube.com/watch?v=mF08O2mL7zY",

  video19Title: "TV2 Fyn",
  video19Description: "Bez mobilnog kada ekran postane crn",
  video19Url:
    "https://play.tv2.dk/serie/mobilfri-naar-skaermen-gaar-i-sort-tv2fyn",

  video20Title: "DR Ultra",
  video20Description: "Laž ili činjenica - zečevi skaču na trampolinu",
  video20Url:
    "https://www.dr.dk/drtv/se/ultra-nyt_-fake-eller-fakta_-kaniner-hopper-paa-trampolin_533209",

  // Podcast translations
  podcast1Title: "Da li gledate previše ekrana?",
  podcast1Description: "Kraniebrud podcast o korištenju ekrana",
  podcast1Url: "https://radio4.dk/podcasts/kraniebrud/ser-du-for-meget-sk-rm",

  podcast2Title: "Spotify Podcast",
  podcast2Description:
    "Spirende Sind: En Børne- og ungdomsppsykiatrisk podcast",
  podcast2Url: "https://open.spotify.com/episode/7stFudvRMPXrW5clAcxCYm",

  podcast3Title: "CyberSundhed",
  podcast3Description: "Aida Bikic u CyberSundhed podcastu",
  podcast3Url:
    "https://creators.spotify.com/pod/profile/cybersundhed/episodes/--Aida-Bikic--CyberSundhed-e2k6mev",

  podcast4Title: "CyberSundhed - Boundaries give children security",
  podcast4Description: "Digitalno zdravlje i djeca",
  podcast4Url: "https://www.youtube.com/watch?v=gOqF-wWl1qI",

  podcast5Title: "Spotify Episode",
  podcast5Description: "Intervju sa Signe",
  podcast5Url: "https://open.spotify.com/episode/0uTamNr0fQvP7aygp4zyTz",

  podcast6Title: "Brainstorm Podcast",
  podcast6Description: "Zašto mi je tako teško da odložim telefon?",
  podcast6Url:
    "https://podcasts.apple.com/ga/podcast/hvorfor-har-jeg-s%C3%A5-sv%C3%A6rt-ved-at-l%C3%A6gge-min-mobil-v%C3%A6k/id1449966468?i=1000671757018",

  podcast7Title: "WDR Studio Interview",
  podcast7Description:
    "Dr. Morsi Abdallah - Specijalista za dječiju i adolescentnu psihijatriju",
  podcast7Url:
    "https://www1.wdr.de/lokalzeit/fernsehen/suedwestfalen/studiogespraech-dr-morsi-abdallah-facharzt-fuer-kinder-und-jugendpsychiatrie-und-psychotherapie-100.html",

  podcast8Title: "Psychologos Podcast",
  podcast8Description: "Društveni mediji II - Asocijalni mediji sa Aidom Bikic",
  podcast8Url:
    "https://www.podcast.de/episode/672508393/social-media-teil-ii-asocial-media-mit-aida-bikic",

  podcast9Title: "WDR Cosmo",
  podcast9Description: "Počinje digitalna detoksikacija školstva",
  podcast9Url:
    "https://www1.wdr.de/mediathek/audio/cosmo/bosnisch-kroatisch-serbisch/audio-pocinje-digitalna-detoksikacija-skolstva-102.html",

  podcast10Title: "YouTube Interview BIH",
  podcast10Description: "Digitalna detoksikacija",
  podcast10Url: "https://www.youtube.com/watch?v=NKl_t5UP_TA",

  podcast11Title: "Avaz Interview",
  podcast11Description: "Korištenje ekrana i djeca",
  podcast11Url: "https://www.youtube.com/watch?v=1tl6CIbhiTY&t=190s",

  watchButton: "Pogledaj video",
  learnMoreButton: "Saznaj više",
};
